/**
 * L1J Web Client - Entry Point
 */

import Phaser from 'phaser';
import { BootScene } from './game/scenes/BootScene';
import { LoginScene } from './game/scenes/LoginScene';
import { CharSelectScene } from './game/scenes/CharSelectScene';
import { CharCreateScene } from './game/scenes/CharCreateScene';
import { GameScene } from './game/scenes/GameScene';
import { loadRuntimeConfig } from './runtimeConfig';
import { introOverlay } from './ui/IntroOverlay';
import { isIntroRoute } from './utils/route';

console.log('L1J Web Client initializing...');

// Phaser 게임 설정
const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 1024,
  height: 768,
  parent: 'app',
  backgroundColor: '#0a0a15',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  render: {
    pixelArt: false,
    antialias: true,
  },
  scene: [BootScene, LoginScene, CharSelectScene, CharCreateScene, GameScene],
  dom: {
    createContainer: true,
  },
};

// `/` 로 들어온 사람에게는 로그인 폼 대신 인트로를 덮어 두고 체험 계정으로 곧장
// 월드까지 들여보낸다(`/login`은 기존 로그인 폼). config.json을 읽는 동안에도
// 화면이 비어 있으면 안 되므로 게임 인스턴스보다 먼저 띄운다.
if (isIntroRoute()) {
  introOverlay.mount();
}

// 게이트웨이 주소를 config.json에서 먼저 읽은 뒤 게임을 띄운다.
// 순서가 중요하다 — LoginScene이 ServerConfig.GATEWAY_URL로 접속을 시도하므로
// 씬이 시작되기 전에 override가 적용돼 있어야 한다. 로드 실패해도 기본값으로 진행한다.
loadRuntimeConfig().then(() => {
  // Phaser 게임 인스턴스 생성
  const game = new Phaser.Game(config);

  // 디버깅을 위한 글로벌 노출
  (window as any).l1j = {
    game,
    Phaser,
  };

  console.log('L1J Web Client started!');
});
